import React from 'react';

import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { times } from 'lodash';
import _ from 'mudash';
import cn from 'classnames';
import styles from './style.scss';
import Tile from './tile';
import { LocaleWrapper } from '../../locale-wrapper';
import PaginationContainer from './pagination_container';

function Columns({ rowIndex, events, settings, columns, onResizeComponent }) {
  const col = 12 / columns;
  return (
    <Row className={cn(styles.inlineFlex, 'columns', { [styles.column]: rowIndex !== 0 })}>
      {times(events.count(), (index) => (
        <Col xs={col} md={col}>
          <Tile
            key={events.getIn([index, 'id'])}
            event={events.get(index)}
            events={events}
            settings={settings}
            className={styles.columnTile}
            onResizeComponent={onResizeComponent}
          />
        </Col>
      ))}
    </Row>
  );
}

export default function ColumnLayout({ columns, events, settings, onResizeComponent }) {
  const renderEvent = (event, index) => (
    <LocaleWrapper event={event}>
      <Columns rowIndex={index} events={event} settings={settings} columns={columns} onResizeComponent={onResizeComponent} />
    </LocaleWrapper>
  );
  return (
    <PaginationContainer
      transform={(eventsToTransform) => _.chunk(eventsToTransform, columns)}
      events={events}
      settings={settings}
      onResizeComponent={onResizeComponent}
      renderEvent={renderEvent}
    />
  );
}

Columns.propTypes = {
  columns: PropTypes.number,
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

ColumnLayout.propTypes = {
  columns: PropTypes.number,
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};
